export const ROLES = {
    CONTEST_PARTICIPANT: 'CONTEST_PARTICIPANT',
    CONTEST_CONTROLLER: 'CONTEST_CONTROLLER',
    ROLE_ADMIN: 'ROLE_ADMIN',
    ROLE_VNII: 'ROLE_VNII',
    ROLE_CZN_MANAGER: 'ROLE_CZN_MANAGER',
    ROLE_CZN_TERRITORIAL: 'ROLE_CZN_TERRITORIAL',
    ROLE_REGIONAL_AGENCY: 'ROLE_REGIONAL_AGENCY',
    ROLE_REGIONAL_ADMINISTRATOR: 'ROLE_REGIONAL_ADMINISTRATOR',
    ROLE_MINTRUD: 'ROLE_MINTRUD'
}